//Built-in libraries
import { useState } from 'react';

//Third party libraries
//Custom components
import Modal from '../UI/Modal';
import { WorkspaceForm } from './WorkspaceForm';
import { WorkspaceDropdown } from './WorkspaceDropdown';

//Services
//Assets andd Miscellaneous
import { IWorkspace } from '../../types/Workspace';

//Component Begin
export const Workspace = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState<IWorkspace>();

  const toggleWorkspaceModal = () => {
    setShowModal((prev) => !prev);
  };

  const editWorkspaceHandler = (data: IWorkspace) => {
    setSelectedWorkspace(data);
    toggleWorkspaceModal();
  };

  return (
    <>
      <WorkspaceDropdown
        handleAddWorkspace={() => toggleWorkspaceModal()}
        handleEditWorkspace={editWorkspaceHandler}
      />
      {showModal && (
        <Modal>
          <WorkspaceForm
            workspace={selectedWorkspace}
            handleSubmit={() => {
              toggleWorkspaceModal();
              setSelectedWorkspace(undefined);
            }}
            onCancel={() => {
              toggleWorkspaceModal();
              setSelectedWorkspace(undefined);
            }}
          />
        </Modal>
      )}
    </>
  );
};
